import { render, staticRenderFns } from "./NationList.vue?vue&type=template&id=36186be4&scoped=true"
import script from "./NationList.vue?vue&type=script&lang=js"
export * from "./NationList.vue?vue&type=script&lang=js"
import style0 from "./NationList.vue?vue&type=style&index=0&id=36186be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36186be4",
  null
  
)

export default component.exports